export default {
  "app": {
    "terms_and_conditions": "terms & conditions",
    "privacy_policy": "privacy policy",
    "acceptable_policy": "acceptable use policy"
  },
  "spotlight": {
    "emptyState": "Search for any object in your workspace!",
    "noResults": {
      "title": "No Results Found",
      "description": "Try adjusting your search or filters to find what you are looking for."
    }
  }
};
